import React from 'react';
import BaseModal from '../BaseModal';
import SourceList from './SourceList';

// "What goes in this box?" — asked as soon as a box is drawn, and again
// whenever the author wants to change what fills one. Cancelling a box that
// was only just drawn takes it off the page: nothing was chosen for it, so the
// drawing is undone with the question.
const BoxPickerModal = ({ open, isNew, formName, groups, placed, onPick, onCancel }) => (
  <BaseModal
    open={open}
    titleId="box-picker-title"
    title="What goes in this box?"
    message="Pick a question from the form, a detail of the submission, or your own text."
    onSubmit={(e) => e.preventDefault()}
    onCancel={onCancel}
    showConfirm={false}
    cancelLabel={isNew ? 'Cancel and remove the box' : 'Cancel'}
    widthClass="max-w-lg"
    bodyClassName="px-5 py-3"
  >
    <div className="max-h-[55vh] overflow-y-auto pr-1">
      <SourceList formName={formName} groups={groups} placed={placed} onPick={onPick} />
    </div>
  </BaseModal>
);

export default BoxPickerModal;
